import { getAction } from '@/api/manage'

const queryDepartList= (params)=>getAction("/portal/sys/depart/list",params);
const getArticleList= (params)=>getAction("/portal/sys/cmsArticle/list",params);
const getArticleHome= (params)=>getAction("/portal/sys/cmsArticle/home",params);

const getPidClassify= (params)=>getAction("/portal/sys/cmsArtClassify/getPidClassify",params);

const getClassifyList= (params)=>getAction("/portal/sys/cmsArtClassify/list",params);

const queryById= (params)=>getAction("/portal/sys/cmsArticle/queryById",params);

const categoryChildList= (params)=>getAction("/portal/sys/categoryChildList",params);

const queryTmSecTenderList= (params)=>getAction("/portal/ebid-ce/queryTmSecTenderList",params);

const queryPortalOldTenderList = (params)=>getAction("/portal/ebid-ce/queryPortalOldTenderList",params);

const queryOldTenderList = (params)=>getAction("/portal/ebid-ce/queryOldTenderList",params);

const queryTmSecTenderHomeList= (params)=>getAction("/portal/ebid-ce/queryTmSecTenderHomeList",params);

const getTenderInfoById = (params)=>getAction("/portal/ebid-ce/tmSecTender/queryById",params);

const getOldTenderInfoById = (params)=>getAction("/portal/ebid-ce/tmSecTender/oldQueryById",params);
const getOldBidOpenById = (params)=>getAction("/portal/ebid-ce/tmBidOpen/oldQueryById",params);

const getCandidateInfoById = (params)=>getAction("/portal/ebid-ce/tmCandidateNotice/queryById",params);

const getOldCandidateInfoById = (params)=>getAction("/portal/ebid-ce/tmCandidateNotice/oldQueryById",params);

const getPitchonInfoById = (params)=>getAction("/portal/ebid-ce/tmPitchonNotice/queryById",params);

const getOldPitchonInfoById = (params)=>getAction("/portal/ebid-ce/tmPitchonNotice/oldQueryById",params);

const queryTmRoomScheduleList = (params)=>getAction("/portal/ebid-ce/queryTmRoomScheduleList",params);

const getFailedInfoById = (params)=>getAction("/portal/ebid-ce/tmFailed/queryById",params);

const getOldFailedInfoById = (params)=>getAction("/portal/ebid-ce/tmFailed/oldQueryById",params);

const getContractInfoById = (params)=>getAction("/portal/ebid-ce/tmSectionContract/queryById",params);

const queryTmBidAgentRank = (params)=>getAction("/portal/ebid-ce/queryTmBidAgentRank",params);

const queryTmBidEntRank = (params)=>getAction("/portal/ebid-ce/queryTmBidEntRank",params);

const queryTmDisuseRecordRank = (params)=>getAction("/portal/ebid-ce/queryTmDisuseRecordRank",params);

const queryTmComplaintInfo = (params)=>getAction("/portal/ebid-ce/queryTmComplaintInfo",params);

const queryBidProjectBriefInfo = (params)=>getAction("/portal/ebid-ce/queryBidProjectBriefInfo",params);

const queryDepositReleasedInfo = (params)=>getAction("/portal/ebid-ce/queryDepositReleasedInfo",params);

const queryGuaranteeAgencyList = (params)=>getAction("/portal/sys/sysGuaranteeAgency/list",params);

export {
  queryDepartList,
  getArticleHome,
  getArticleList,
  getPidClassify,
  getClassifyList,
  queryById,
  queryTmSecTenderList,
  queryTmSecTenderHomeList,
  getTenderInfoById,
  queryTmRoomScheduleList,
  getCandidateInfoById,
  getPitchonInfoById,
  getFailedInfoById,
  getContractInfoById,
  categoryChildList,
  queryTmBidAgentRank,
  queryTmBidEntRank,
  queryTmDisuseRecordRank,
  queryTmComplaintInfo,
  queryBidProjectBriefInfo,
  queryDepositReleasedInfo,
  queryGuaranteeAgencyList,
  queryOldTenderList,
  getOldTenderInfoById,
  getOldCandidateInfoById,
  getOldPitchonInfoById,
  getOldFailedInfoById,
  queryPortalOldTenderList,
  getOldBidOpenById
}


